export const ENGLISH = "eng";
export const CZECH = "cze";
export const ENGLISH_ID = "en";
export const CZECH_ID = "cs";
export const CZECH_REPUBLIC_ID = "cz";
export const SLOVAKIA_ID = "svk";
export const SLOVAK = "slo";
export const SLOVAK_ID = "sv";
